<template>
  <div>
    <FITModal ref="deleteBulletinModal" reference="modal" :title="$t('general.CURD.delete')" @click="onClickModalDelete" size="lg">
      <div slot="body">
        <h5 class="mb-3">{{$t('adm.bulletin.deleteConfirmTitle')}}</h5>
        <p class="my-2"><b>{{$t('adm.bulletin.subject')}}: {{form.subject}}</b></p>
        <p class="my-2"><b>{{$t('adm.bulletin.content')}}: <span v-html="form.content"></span></b></p>
      </div>
    </FITModal>
    <FITFormCard class="mt-0">
      <div slot="header">
        <b-row align-v="center">
          <b-col cols="6">
            <p class="h5" v-if="bulletin">{{$t('adm.bulletin.edit')}} {{$t('adm.bulletin.title')}}</p>
            <p class="h5" v-else>{{$t('general.CURD.create')}} {{$t('adm.bulletin.title')}}</p>
          </b-col>
          <b-col cols="auto" class="ml-auto" v-if="bulletin">
            <FITButton size="md" :text="$t('general.CURD.delete')" variant="danger" @click="onClickDelete"></FITButton>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody" class="pt-0">
        <b-row>
          <b-col cols="9">
            <div class="form-group" :class="{ 'form-group--error': $v.form.subject.$error }">
              <FITTextInput :rule="{required:true}" :label="$t('home.message.subject')" :placeholder="$t('home.message.bulletinSubject')" :width="11" v-model.trim="$v.form.subject.$model" :disabled="isloading"></FITTextInput>
              <!-- <div class="error" v-if="!$v.form.subject.required">Field is required</div> -->
            </div>
          </b-col>
          <b-col cols="3">
            <FITSelect :rule="{required:true}" :label="$t('adm.bulletin.category')" :options="categories" :selectSize="1" value="M" :width="8" v-model="form.category" :disabled="isloading"></FITSelect>
            <FITSelect :label="$t('adm.bulletin.provider')" :options="providers" :multiple="true" :selectSize="5" value="M" :width="8" v-model="form.providerID" :disabled="isloading"></FITSelect>
            <FITSelect :label="$t('adm.bulletin.policyType')" :options="policyTypes" :multiple="true" :selectSize="2" value="M" :width="8" v-model="form.policyType" :disabled="isloading"></FITSelect>
          </b-col>
        </b-row>
        <!-- https://github.com/surmon-china/vue-quill-editor#vue-quill-editor -->
        <quill-editor :disabled="isloading" ref="editor" v-model="form.content" :options="editorOptions" @change="onEditorChanged"></quill-editor>
        <b-row align-v="center">
          <b-col cols="8" class="my-2">
            <p class="h6 text-muted">{{ count }}</p>
          </b-col>
          <b-col cols="4" class="text-right">
            <!-- <FITButton size="md" text="Submit" variant="primary" @click="create" :disabled="$v.$invalid"></FITButton> -->
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col>
            <FITWorkflowFileUpload ref="attachmentUpload" @onRemoveOldFile="onRemoveOldFile" :oldFileRemovable="true" :uploadedFiles="uploadedFiles"></FITWorkflowFileUpload>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-right">
            <FITButton size="md" text="Submit" variant="primary" @click="create" :disabled="$v.$invalid"></FITButton>
          </b-col>
        </b-row>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import {
  FITTextInput,
  FITSelect,
  FITFormCard,
  FITButton,
  FITWorkflowFileUpload,
  FITModal,
  FITAutoSearch
} from '@/components';

import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'BulletinCreate',
  components: {
    FITTextInput,
    FITFormCard,
    FITSelect,
    FITButton,
    FITWorkflowFileUpload,
    FITModal,
    FITAutoSearch
  },
  methods: {

    getProviderOptions() {
      this.$store.dispatch('Adm/getProviderOptions', { count: 2000 }).then((json) => {
        Vue.set(this, 'providerList', json.data.list);
      }).catch((err) => {
        console.error(err);
      })
    },
    onClickModalDelete(evt) {
      if (!evt) {
        return;
      }
      this.$store.dispatch('Adm/deleteBulletin', { ID: this.bulletin }).then((json) => {
        this.$refs.deleteBulletinModal.closeModal();
        this.$router.replace({
          name: 'Bulletin List',
          params: { alertContent: this.$t('general.deleteSuccess'), alertVariant: 'success' }
        })
      })
    },
    onClickDelete() {
      this.$refs.deleteBulletinModal.openModal();
    },
    onRemoveOldFile(index) {
      this.uploadedFiles.splice(index, 1);
    },
    onEditorChanged(evt) {
      Vue.set(this, 'count', `${this.$refs.editor.quill.getLength() - 1} / 2000 ${this.$t('home.message.word')}`);
    },
    uploadAttachment() {
      var fileData = this.$refs.attachmentUpload.formUploadFiles();
      Vue.set(this.form, 'attachment', fileData.attachment);
      Vue.set(this.form, 'files', fileData.files);
    },
    create() {
      if (this.$v.$invalid) {
        console.debug('error');
        return;
      }

      this.uploadAttachment();

      let data = {
        ...this.form,
        preview: this.$refs.editor.quill.getText(0, 149)
      }

      delete data.chineseName;
      delete data.englishName;
      delete data.attachments;

      console.debug(data);

      let action = 'Adm/createBulletin'
      if (data.ID) {
        action = 'Adm/editBulletin';
      }
      console.debug(data.ID)
      this.$store.dispatch(action, data)
        .then((json) => {
          this.$router.push('/adm/bulletin/list');
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setUpUploadedAttachment(newData) {
      for (var i = 0; i < newData.length; i++) {
        var fileName = newData[i].documentName;
        var size = newData[i].fileSize;
        var publicDocument = newData[i].publicDocument;
        var remarks = newData[i].remarks;
        var documentTag = newData[i].documentTag;
        var ID = newData[i].ID;
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag, ID })
      }
    }
  },

  validations: {
    form: {
      subject: {
        required
      },
      content: {
        required
      },
      category: {
        required
      }
    }
  },

  computed: {
    ...mapGetters("Adm", [
      'getTranslated'
    ]),
    categories() {
      return this.getTranslated(this.$i18n.locale, 'category');
    },
    providers() {
      var providers = []
      this.providerList.forEach((item) => {
        providers.push({ text: item.providerCode, value: item.ID });
      })
      return providers;
    },
    policyTypes() {
      return this.getTranslated(this.$i18n.locale, 'policyType');
    }
  },

  props: {
    bulletin: {
      type: Number,
      default: null
    },
  },

  data() {
    return {
      providerList: [],
      selectedProvider: '',
      isloading: false,
      count: `0 / 2000 ${this.$t('home.message.word')}`,
      uploadedFiles: [],
      form: {
        subject: '',
        content: '',
        category: 'M',
        attachment: {},
        files: [],
        providerID: [],
        policyType: []
      },
      editorOptions: {
        placeholder: this.$t('home.message.bulletinContent'),
        theme: 'snow',
        modules: {
          toolbar: [
            [{ 'header': 1 }, { 'header': 2 }],
            ['bold', 'italic', 'underline', 'link', 'align'],
            ['blockquote', { 'list': 'ordered' }, { 'list': 'bullet' }]
          ],
        }
      },
      providerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'provider' }],
        showItems: ['providerCode'],
      },
    }
  },
  created() {
    Vue.set(this, 'isloading', true);
    this.getProviderOptions();
    this.$store.dispatch('getAllSelections', 'bulletin')
      .then((json) => {
        this.$store.commit({
          type: 'Adm/setSelections',
          selections: json.data
        });

        if (this.bulletin) {

          this.$store.dispatch('Adm/getBulletinDetail', {
              ID: this.bulletin
            })
            .then((json) => {
              console.debug(json);
              Vue.set(this, 'form', json);
              this.setUpUploadedAttachment(json.attachments);
              Vue.set(this, 'isloading', false);
            })
            .catch((err) => {
              console.debug(err);
            });
        } else {
          Vue.set(this, 'isloading', false);
        }
      });
  },
  mounted() {
    this.$refs.editor.quill.format('font', 'Arial');
  }
}

</script>
<style>
.ql-container .ql-editor {
  height: 35rem;
}

.ql-editor {
  font-size: 16px
}

</style>



// WEBPACK FOOTER //
// src/Adm/Bulletin/BulletinCreate.vue